"use client";

import * as React from "react";

/**
 * True once this component has mounted in the browser.
 *
 * Why it exists: a form whose only submit handler is React's `onSubmit` is
 * present in the HTML before React attaches that handler. Anything submitted
 * in that window -- a fast typist, a password manager's auto-submit, Enter in
 * the last field, or simply a slow bundle -- performs the browser's own
 * default submit instead. For a form with no `action`, that is a GET to the
 * same URL carrying every field as a query parameter, which puts a password
 * in the address bar, the browser history, the referrer and every proxy and
 * access log along the way.
 *
 * Gate the submit control on this, and give the form `method="post"` as the
 * second line of defence: if a submit still escapes, the credentials travel
 * in a request body that goes nowhere, never in a URL.
 */
/** Nothing to subscribe to: the value only differs between server and client. */
const noSubscription = () => () => {};

export function useHydrated(): boolean {
  return React.useSyncExternalStore(
    noSubscription,
    () => true, // in the browser, once React is running
    () => false, // during server rendering, and the hydration pass that matches it
  );
}
